/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useFetchCitiesPreload } from "../../api/queries/homeQueries";
import ProdCard from "../../components/box/ProdCard";
import { LvlPagi } from "../../components/layout/LvlPagi";
import { NoResultsWereFound } from "../../components/not-found/NoResultsWereFound";
import ProductService from "../../services/productService";

const TicketListView: React.FC = () => {
  // Pagination configuration
  const [data, setData] = useState<ProductBaseResponse[]>([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const keyword = params.get("keyword");
  const [selectedCheckbox, setSelectedCheckbox] = useState<string[]>([]);
  const [selectedCheckbox2, setSelectedCheckbox2] = useState<string[]>([]);
  const [totalElements, setTotalElements] = useState(0);
  const { t } = useTranslation();
  const fetchProducts = async (pageIndex: number = 0) => {
    try {
      const response = await ProductService.getProductsList({
        keyword: keyword,
        pageIndex: pageIndex,
        pageSize: 9,
        productType:
          selectedCheckbox2 && selectedCheckbox2.length > 0
            ? selectedCheckbox2.toString()
            : undefined,
        cities:
          selectedCheckbox && selectedCheckbox.length > 0
            ? selectedCheckbox.toString()
            : undefined,
      });
      setData(response.data as ProductBaseResponse[]);
      setTotalPages(response.totalPages);
      setCurrentPage(response.pageIndex);
      setTotalElements(response.totalElements);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  useEffect(() => {
    fetchProducts(0);
  }, [selectedCheckbox, selectedCheckbox2]);

  const handlePageChange = (newPage: number) => {
    fetchProducts(newPage);
  };

  const getCategoryBackgroundColor = (category: string) => {
    switch (category) {
      case "Premium":
        return "bg-red-500"; // Red for Premium
      case "Silver":
        return "bg-blue-500"; // Blue for Standard
      default:
        return "hidden"; // Hide if no category
    }
  };

  const handleCheckboxChange = (value: string) => {
    if (selectedCheckbox.includes(value)) {
      setSelectedCheckbox(selectedCheckbox.filter((item) => item !== value));
    } else {
      setSelectedCheckbox([...selectedCheckbox, value]);
    }
  };

  const handleCheckboxChange2 = (value: string) => {
    if (selectedCheckbox2.includes(value)) {
      setSelectedCheckbox2(selectedCheckbox2.filter((item) => item !== value));
    } else {
      setSelectedCheckbox2([...selectedCheckbox2, value]);
    }
  };

  return (
    <div className="mt-8 flex flex-col items-center">
      <h1 className="w-[78.5rem] text-[1.50rem] font-semibold text-black">
        {t("Result for ")}“{keyword}”
      </h1>
      <div className="mt-6 flex w-[78.5rem] gap-[1.88rem]">
        <div className="flex w-[18.375rem] flex-col gap-[1.88rem]">
          {/* Filters section omitted for brevity */}
          <WhereTo
            selectedCheckbox={selectedCheckbox || ""}
            handleCheckboxChange={handleCheckboxChange}
          />

          <div className="flex flex-col justify-start gap-[1.25rem] rounded-[1.25rem] bg-[#F7F8FA] px-[1.13rem] py-[1.75rem]">
            <div className="flex self-stretch">
              <h6 className="text-gray-900_01 text-[1.13rem] font-semibold">
                {t("Categories")}
              </h6>
            </div>
            <div className="flex flex-col gap-[1.13rem] self-stretch">
              <div className="flex flex-col gap-[0.63rem]">
                {[
                  { value: "PASS", label: t("Big Pass") },
                  { value: "TICKET", label: t("Ticket") },
                  { value: "TOUR", label: t("Tour") },
                  { value: "MUSICAL", label: t("Musical") },
                  { value: "SIM", label: t("Sim") },
                ].map(({ value, label }) => (
                  <div className="flex items-center justify-center" key={value}>
                    <input
                      className="custom-checkbox"
                      type="checkbox"
                      checked={selectedCheckbox2.includes(value)}
                      onChange={() => handleCheckboxChange2(value)}
                    />
                    <div className="flex flex-1 px-[0.75rem]">
                      <p className="text-[0.94rem] font-normal text-[#5E6D77]">
                        {label}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-1 flex-col gap-[2.50rem]">
          {!totalElements ? (
            <NoResultsWereFound />
          ) : (
            <div className="flex">
              <p className="text-[1.00rem] font-normal text-[#5E6D77]">
                {totalElements} {t("results found")}
              </p>
            </div>
          )}
          <div className="flex flex-col items-center gap-[4.38rem]">
            <div className="grid grid-cols-3 justify-center gap-[1.50rem] self-stretch">
              {data.map((item) => (
                <ProdCard key={item.id} {...item} />
              ))}
            </div>
            <LvlPagi
              totalPages={totalPages}
              currentPage={currentPage}
              handlePageChange={handlePageChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TicketListView;

const pageSize = 4;
const WhereTo = (props: {
  selectedCheckbox: string[];
  handleCheckboxChange: (value: string) => void;
}) => {
  const { t } = useTranslation();
  const {
    data: citiesData,
    // hasNextPage,
    // fetchNextPage,
  } = useFetchCitiesPreload({
    pageSize: 999999,
  });
  const [hasNextPage, setHasNextPage] = useState(true);
  const fetchNextPage = () => {
    setHasNextPage(false);
  };

  const ls = useMemo(() => {
    const ret = citiesData?.pages.flatMap((page) => page.data) ?? [];
    if (hasNextPage) {
      return ret.slice(0, pageSize);
    }
    return ret;
  }, [citiesData, hasNextPage]);

  return (
    <div className="flex flex-col justify-start gap-[1.25rem] rounded-[1.25rem] bg-[#F7F8FA] px-[1.13rem] py-[1.75rem]">
      <div className="flex self-stretch">
        <h6 className="text-[1.13rem] font-semibold text-gray-900">
          {t("Where to?")}
        </h6>
      </div>

      <div className="flex flex-col gap-[1.13rem] self-stretch">
        <div className="flex flex-col gap-[0.63rem]">
          {ls.map((city) => {
            const value = (city.id ?? "").toString();
            return (
              <div className="flex items-center gap-[0.75rem]" key={city.id}>
                <input
                  className="custom-checkbox h-4 w-4 cursor-pointer" // Adjust the size of checkbox
                  type="checkbox"
                  checked={props.selectedCheckbox.includes(
                    (city.id ?? "").toString(),
                  )}
                  onChange={() => props.handleCheckboxChange(value)}
                />
                <div className="flex-1 px-[0.75rem]">
                  <p className="text-[0.94rem] font-normal text-[#5E6D77]">
                    {city.name}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {hasNextPage && (
          <div
            className="flex items-center gap-[0.38rem]"
            onClick={() => fetchNextPage()}
          >
            <span className="text-[1.00rem] font-semibold text-blue-700">
              {t("See more")}
            </span>
            <img
              className="w-[0.5625rem] cursor-pointer"
              src="../../assets/icons/Vector.svg"
              alt="See more"
              loading="lazy"
            />
          </div>
        )}
      </div>
    </div>
  );
};
